module.exports = __webpack_public_path__ + "img/icon-clock-grey.96fb103b.svg";